import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Staking from '../components/updated/Staking';
import { baseURL, decodeJWT, loginWithToken } from '../services/api';
import { useAuth } from '../components/Hooks/useAuth';
import LoginRequiredPopup from '../components/updated/shared/LoginRequiredPopup';

const StakingPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultSignInToken = searchParams.get('signInToken');
  const {
    showLoginPopup,
    handleLoginPopupClose,
    checkAuthentication,
    showLoginRequiredPopup,
  } = useAuth();

  useEffect(() => {
    const redirectFlag = localStorage.getItem('redirected');

    if (defaultSignInToken && !redirectFlag) {
      console.log('I am here ', defaultSignInToken);
      checkLogin(defaultSignInToken);
    } else {
      if (!checkAuthentication()) {
        showLoginRequiredPopup();
      }
    }
  }, [checkAuthentication, showLoginRequiredPopup]);

  async function checkLogin(defaultSignInToken) {
    try {
      const res = await loginWithToken(defaultSignInToken);
      console.log('I am here', res);
      console.log(res);
      if (res.status === 200) {
        let resObj = await decodeJWT(res.data.access_token);

        localStorage.setItem('email', resObj?.email);
        localStorage.setItem('user', resObj?.email);
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('refresh_token', resObj?.refresh_token);
        localStorage.setItem('userType', resObj?.userType);
        localStorage.setItem('redirected', 'true'); // Set flag
        // Store whitelisted status from backend response
        if (res?.data?.whitelisted !== undefined) {
          localStorage.setItem('isWhitelisted', String(res.data.whitelisted));
        }
        window.location.reload();
      } else {
        console.log(res.data);
      }
    } catch (err) {
      console.log('err', err);
    }
  }

  return (
    <div>
      <Staking />
      {showLoginPopup && <LoginRequiredPopup onClose={handleLoginPopupClose} />}
    </div>
  );
};

export default StakingPage;
